module.exports = __webpack_public_path__ + "static/skills-ac8dbafdf432c18a6e4d62a715e84ac3.svg";